import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  EventEmitter,
  Output,
} from '@angular/core';
import * as FileSaver from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import { UploadScanResult } from '../../models/upload-scan-result';
import { UploadService } from '../../services/upload.service';
import { DialogComponent } from '../dialog/dialog.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { interval } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { FieldLength } from '../../general/field-length';
import { FileExtensionEnum } from '../../general/file-extension-enum';
import { FloatMessageService } from '../../services/float-message.service';
import { ActivatedRouteSnapshot } from '@angular/router';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent implements AfterViewInit {
  @ViewChild('fileInput') fileInput: ElementRef;
  readfile: any = [];
  allowFileType: any[];
  errorMessage: string = null;
  alert: boolean = false;
  lockScreen:boolean = false;
  isProxy:boolean = false;
  content: any;
  date: number = Date.now();
  localUrl: any[];
  scan: string = environment.enableVirusScan;
  public uplodedFileSuccessfullyLength: number = 0;
  public uplodedFileSuccessfullyCount: number = 0;
  public uplodedFileCount: number = 0;
  public errorMessagecount:number =0 ;
  @Input('allow-file-type') set _allowFileType(val) {
    this.allowFileType = val;
  }
  allowMulti: boolean;
  @Input('allow-multi') set _allowMulti(val) {
    this.allowMulti = val;
  }
  @Input('file-list') set _files(val) {
     this.azureFiles = val;
  }
  allowFileUpload: boolean = false;
  @Input('allow-File-Upload') set _allowFileUpload(val) {
    this.allowFileUpload = val;
  }
  @Output() emitFiles: EventEmitter<any>;
  @Output() emitDeletedFile: EventEmitter<any>;
  @Output() emitErrorMessage: EventEmitter<any>;
  @ViewChild('fileInput') uploadFileRef: ElementRef;
  public intervalId: any = null;
  public folderPathId: any = null;
  @Input('folder-path-id') set _folderPathId(val) {
    this.folderPathId = val;
  }
  deleteFiles: any[] = [];
  @Input('delete-file') set _deleteFile(val:any) {
    if (val!=null && val.length > 0) {
      this.deleteFiles = val;
      this.deleteAttachment();
    }
  }
  @Input('hide-ErrorMessage') set _errorMessage(val) {
    if (!val) {
      this.alert = val; 
    }
  }
  @Input('lockScreen') set _lockScreen(val) {
      this.lockScreen = val; 
  }
  @Input('isProxy') set _isProxy(val) {
      this.isProxy = val; 
  }
  constructor(
    private spinnerService: NgxSpinnerService,
    private uploadService: UploadService,
    public dialog: MatDialog,
    private floatMessage: FloatMessageService
  ) {
    this.emitFiles = new EventEmitter<any>();
    this.emitDeletedFile = new EventEmitter<any>();
    this.emitErrorMessage = new EventEmitter<any>();
  }
  ngAfterViewInit(): void {
    this.fileInput.nativeElement.multiple = this.allowMulti;
  }

  public uploadedFiles_Copy: any[] = [];
  public isFileTypeSupport: number = 0;
  public isFileSizeExceed: number = 0;
  public isVirusFound: number = 0;
  public isFilePasswordProtected: number = 0;
  public isFileNotProtected = true;
  public fileContents: any = '';
  public azureFiles: any[] = [];
  public uploadScanResult: UploadScanResult[];
  public virusInfectedFiles: any[] = [];
  public unuploadedFilename: string = '';
  public uplodedFileLength: number=0;
  public isFilenameInvalid: number=0;
  public isFileNameInvalidCount:number=0;
  public isFilePathInvalid: number = 0;
  // To upload the multiple files..
  public async onClickToUploadMultipleFiles(uploadedFiles: File[]) {  
    this.unuploadedFilename = '';
    this.uplodedFileSuccessfullyLength = 0;
    this.uplodedFileSuccessfullyCount = 0;
    this.uplodedFileCount = 0;
    this.errorMessagecount=0;
    this.uplodedFileLength = 0;
    this.isFileTypeSupport = 0;
    this.isFilePasswordProtected = 0;
    this.isVirusFound = 0;
    this.isFileSizeExceed = 0;
    this.isFilenameInvalid = 0;
    this.isFileNameInvalidCount=0;
    this.isFilePathInvalid=0;
    this.uplodedFileCount = uploadedFiles.length;
    if(this.azureFiles.length >= 1&& this.isProxy){
      this.errorMessage = "Multiple file upload is not allowed. Please select one file to upload.";
      this.alert = true;
      this.emitErrorMessage.emit();
      return;
    }
    if (uploadedFiles.length > 0) {
      let uploadedData: any = uploadedFiles;
      let copyUploadedData: any = uploadedFiles;
      for (let index1 = 0; index1 < uploadedData.length; index1++) {
        for (let index2 = index1 + 1; index2 < copyUploadedData.length; index2++) {
          if (uploadedData[index1].name === copyUploadedData[index2].name) {
            this.errorMessage = "Duplicate files detected. Please check the file(s) being uploaded.";
            this.alert = true;
            this.emitErrorMessage.emit();
            return;
          }
        }
      }  
      for (let index = 0; index < this.azureFiles.length; index++) {
        let uploadedFile: File = this.azureFiles[index];
        let data :File[] =uploadedFiles;
        for (let index3 = 0; index3 < data.length; index3++) {
          if (data[index3].name == uploadedFile.name) {
            this.errorMessage = "Duplicate files detected.  Please check the file(s) being uploaded.";
            this.alert = true;
            this.emitErrorMessage.emit();
            return;
          }
        }
      }
    }
    this.uploadedFiles_Copy = uploadedFiles;
    this.alert = false;
    this.virusInfectedFiles = [];
    
    if ((!this.allowMulti && uploadedFiles.length === 1) || this.allowMulti) {
      this.spinnerService.show();
      for (let index = 0; index < uploadedFiles.length; index++) {
        let uploadedFile: File = uploadedFiles[index];
        this.uplodedFileLength++;
        if (uploadedFile.size > 10485760) {
          this.isFileSizeExceed++;
          this.unuploadedFilename = this.unuploadedFilename ? this.unuploadedFilename + "," + uploadedFile.name : this.unuploadedFilename + uploadedFile.name;
          this.emitErrorMessageFun();
        } else if (uploadedFile.size <= 10485760) {
          if (this.validateFiles(uploadedFile.name.split('.').pop().toLowerCase()) && !this.isTruncatedFileName(uploadedFile.name)) {
            //file name validation
            if(false)
                {
                  this.isFilenameInvalid++;
                  this.unuploadedFilename = this.unuploadedFilename ? this.unuploadedFilename + "," + uploadedFile.name : this.unuploadedFilename + uploadedFile.name;
                  this.emitErrorMessageFun();
                   continue;
                }
            let showValidPDF: boolean = false;
            let isPDFProtected: boolean = false;
            let fileReader = new FileReader();

            fileReader.onload = (e) => {
              let contents: any = e.target.result;
              var data = contents.substr(0, 8);
              var regex = new RegExp('%PDF-1.[0-7]');
              if (data.match(regex)) {
                if(contents.indexOf('/Filter/FlateDecode') !== 1){
                  showValidPDF = true;
                }
                else{
                  showValidPDF = false;
                }

                if (showValidPDF && contents.indexOf('/Encrypt') > 1) {
                  isPDFProtected = true;
                }
              }

              if (
                contents.indexOf('keyEncryptor/password') !== -1 ||
                isPDFProtected
              ) {
                this.isFilePasswordProtected++;
                this.unuploadedFilename = this.unuploadedFilename ? this.unuploadedFilename + "," + uploadedFile.name : this.unuploadedFilename + uploadedFile.name;
                this.emitErrorMessageFun();
              } else {
               try{
                  var convertedFileName = btoa(uploadedFile?.name);
                  this.scanAndValidateFile(
                  uploadedFile,
                  index,
                  this.folderPathId);
               }catch(error){
                  this.isFileNameInvalidCount++;
                  this.unuploadedFilename = this.unuploadedFilename ? this.unuploadedFilename + "," + uploadedFile.name : this.unuploadedFilename + uploadedFile.name;
                  this.emitErrorMessageFun();
               }
                
              }
            };

            fileReader.readAsText(uploadedFile);
          } 
          else if(this.isTruncatedFileName(uploadedFile.name)){
            this.isFilePathInvalid++;
            this.unuploadedFilename = this.unuploadedFilename ? this.unuploadedFilename + "," + uploadedFile.name : this.unuploadedFilename + uploadedFile.name;
            this.emitErrorMessageFun();
          }else {
            this.isFileTypeSupport++;
            this.unuploadedFilename = this.unuploadedFilename ? this.unuploadedFilename + "," + uploadedFile.name : this.unuploadedFilename + uploadedFile.name;
            this.emitErrorMessageFun();
          }

          
          
        }
      }
      this.spinnerService.hide();
    }

    // this.intervalId = setInterval(() => {
     // if (this.uplodedFileLength == uploadedFiles.length) {
      //   if (this.isVirusFound != 0) {
      //     this.errorMessage = "Please re-upload a fresh file instead of as it is virus infected";
      //     this.alert = true;
      //     this.emitErrorMessage.emit();
      //   }
      //   else if (uploadedFiles.length > 1 && (this.isFileSizeExceed != 0 || this.isFileTypeSupport != 0 || this.isFilePasswordProtected != 0 || this.isFilenameInvalid != 0)) {
      //     this.errorMessage = "Upload unsuccessful for " + this.unuploadedFilename  +" as it does not meet the file upload requirements. Please upload a different file. ";
      //     this.alert = true;
      //     this.emitErrorMessage.emit();
      //   }
      //   else if (this.isFileSizeExceed != 0) {
      //     this.errorMessage = "Upload unsuccessful - File size should not exceed 10 MB ";
      //     this.alert = true;
      //     this.emitErrorMessage.emit();
      //   }
      //   else if (this.isFileTypeSupport != 0) {
      //     this.errorMessage = " Upload unsuccessful - Upload the documents in supported format only";
      //     this.alert = true;
      //     this.emitErrorMessage.emit();
      //   }
      //   else if (this.isFilePasswordProtected != 0) {
      //     this.errorMessage = "Upload unsuccessful – Encrypted file is not supported";
      //     this.alert = true;
      //     this.emitErrorMessage.emit();
      //   } else if (this.isFilenameInvalid != 0) {
      //     this.errorMessage = 'Upload unsuccessful - Invalid file name format. Please ensure that the filenames do not contain apostrophe (" \' "), semicolon (";") and equals sign ("=").';
      //     this.alert = true;
      //     this.emitErrorMessage.emit();
      //   } 
      //   this.uplodedFileLength = 0;
      //   this.isFileTypeSupport = 0;
      //   this.isFilePasswordProtected = 0;
      //   this.isVirusFound = 0;
      //   this.isFileSizeExceed = 0;
      //   this.isFilenameInvalid = 0;
      //   this.unuploadedFilename = '';
      // }
    // },2000);
  }
  isTruncatedFileName(fileName: string): boolean {
    // Check if the filename contains a tilde (~) followed by a number
    const shortNamePattern = /\~\d+\.[A-Z]{3}$/; // Matches "~1.HEI" or similar
    return shortNamePattern.test(fileName);
  }

  emitErrorMessageFun() {
    if (this.isVirusFound != 0) {
      this.errorMessage = "Please re-upload a fresh file instead of as it is virus infected";
      this.alert = true;
      this.emitErrorMessage.emit();
    }
    else if (this.uplodedFileCount> 1 && (this.isFileSizeExceed != 0 || this.isFileTypeSupport != 0 || this.isFilePasswordProtected != 0 || this.isFilenameInvalid != 0 || this.isFileNameInvalidCount != 0)) {
      this.errorMessage = "Upload unsuccessful for " + this.unuploadedFilename  +" as it does not meet the file upload requirements. Please upload a different file. ";
      this.alert = true;
      this.emitErrorMessage.emit();
    }
    else if (this.isFileSizeExceed != 0) {
      this.errorMessage = "Upload unsuccessful - File size should not exceed 10 MB ";
      this.alert = true;
      this.emitErrorMessage.emit();
    }
    else if (this.isFileTypeSupport != 0) {
      this.errorMessage = " Upload unsuccessful - Upload the documents in supported format only";
      this.alert = true;
      this.emitErrorMessage.emit();
    }
    else if (this.isFilePasswordProtected != 0) {
      this.errorMessage = "Upload unsuccessful – Encrypted file is not supported";
      this.alert = true;
      this.emitErrorMessage.emit();
    } else if (this.isFilenameInvalid != 0) {
      this.errorMessage = 'Upload unsuccessful - Invalid file name format. Please ensure that the filenames do not contain apostrophe (" \' "), semicolon (";") and equals sign ("=").';
      this.alert = true;
      this.emitErrorMessage.emit();
    } else if (this.isFileNameInvalidCount != 0) {
      this.errorMessage = 'Upload unsuccessful - Invalid file name format.',
      this.alert = true;
      this.emitErrorMessage.emit();
    } else if (this.isFilePathInvalid != 0) {
      this.errorMessage = 'Upload failed. File name or path is too long. Shorten the name or use a shorter folder path and try again.',
      this.alert = true;
      this.emitErrorMessage.emit();
    } 

  }

  private showErrorPopup() {
    if (
      this.isVirusFound >= 1 ||
      this.isFileSizeExceed >= 1 ||
      this.isFileTypeSupport >= 1 ||
      this.isFilePasswordProtected >= 1
    ) {
      let errorResponseMessage: any ='<ul><li>1. Upload the documents in supported format only.</li><li>2. Make sure that document(s) are not password protected.</li><li>3. Each file size should not exceed 10 MB.</li></ul>';

      if (this.isVirusFound > 1 && this.virusInfectedFiles.length > 1) {

        errorResponseMessage ='<ul><li>1. Upload the documents in supported format only.</li><li>2. Make sure that document(s) are not password protected.</li><li>3. Each file size should not exceed 10 MB.</li><li>4. Kindly re-upload a fresh file instead of the following, as these are virus infected - <br><br>' +this.virusInfectedFiles +'</li></ul>';
      } else if ( this.isVirusFound == 1 && this.virusInfectedFiles.length == 1) {

        errorResponseMessage ='<ul><li>1. Upload the documents in supported format only.</li><li>2. Make sure that document(s) are not password protected.</li><li>3. Each file size should not exceed 10 MB.</li><li>4. Kindly re-upload a fresh file instead of ' + this.virusInfectedFiles[0] +' as this is  virus infected.</li></ul>';
      }

      this.dialog.open(DialogComponent, {
        disableClose: true,
        width: '1000px',

        data: {
          title: true,
          oneButton: true,
          labelVal: 'Upload Failed',
          labelVal1: 'Please ensure the following-',
          labelVal2: errorResponseMessage,
          primaryButVal: 'OK',
        },
        panelClass: 'warning',
      });

      this.isFileTypeSupport = 0;
      this.isFilePasswordProtected = 0;
      this.isVirusFound = 0;
      this.isFileSizeExceed = 0;
    }
  }

  validateFiles(fileExtension: string): boolean {
    fileExtension = fileExtension.toLowerCase();
    if (
      fileExtension == 'pdf' ||
      fileExtension == 'xls' ||
      fileExtension == 'xlsx' ||
      fileExtension == 'jpg' ||
      fileExtension == 'jpeg' ||
      fileExtension == 'heic' ||
      fileExtension == 'gif' ||
      fileExtension == 'ppt' ||
      fileExtension == 'pptx' ||
      fileExtension == 'doc' ||
      fileExtension == 'docx'
    ) {
      return true;
    } else {
      return false;
    }
    
  }

  public readFile(file: any) {
    if (file.getDetails) {
      this.uploadService.downloadFile(file.filePath, file.name);
    }
    else {
      this.readfile = file;

      if (!this.readfile) {
        return;
      }
      const reader = new FileReader();

      reader.onload = (e: any) => {
        let contents = e.target.result;
        this.displayContents(contents, this.readfile);
      };

      reader.readAsBinaryString(this.readfile);
    }
  }

  displayContents(binaryString, file: File) {
    let extension = file.name.substring(file.name.lastIndexOf('.'));
    let len = binaryString.length;
    let arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binaryString.charCodeAt(i);
    }
    let mimetype = this.getMimetype(extension);

    let data = new Blob([arr], {
      type: mimetype,
    });

    FileSaver.saveAs(data, file.name);
  }

  private getMimetype(extension) {
    let mimetype;

    switch (extension) {
      case '.gif':
        mimetype = 'image/gif';
        break;
      case '.jpeg':
      case '.jpg':
        mimetype = 'image/jpeg';
        break;
      case '.heic':
        mimetype = 'image/heic';
        break;
      case '.xls':
        mimetype = 'application/vnd.ms-excel';
        break;
      case '.pptx':
        mimetype =
          'application/vnd.openxmlformats-officedocument.presentationml.presentation';
        break;
      case '.xlsx':
        mimetype =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case '.docx':
        mimetype =
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      case '.dotx':
        mimetype =
          'application/vnd.openxmlformats-officedocument.wordprocessingml.template';
        break;
      case '.ppt':
        mimetype = 'application/vnd.ms-powerpoint';
        break;
      case '.pptm':
        mimetype = 'application/vnd.ms-powerpoint.presentation.macroenabled.12';
        break;
      case '.doc':
        mimetype = 'application/msword';
        break;
      case '.pdf':
        mimetype = 'application/pdf';
        break;
      default:
        break;
    }

    if (mimetype) {
      return mimetype;
    }
  }

  // To scan and validate the file..
  public async scanAndValidateFile(
    file: File,
    indexPosition: number,
    folderPathId: string
  ) {
    const formData = new FormData();
    let fileToUpload:any = file;

    //A condition to manually set the mime type for HEIC file type 
    if(file?.name.split('.').pop().toLowerCase() ==FileExtensionEnum.HEIC){
      //Convert to byte array
      const arrBuffer =  await fileToUpload?.arrayBuffer();
      const byteArray = new Uint8Array(arrBuffer);
    
      //Add to a blob
      var blobData = new Blob([byteArray], { type: FileExtensionEnum.HEICMimetype });
      //Generate file from blob with Mime Type and set it as a final file
      fileToUpload = new File([blobData], file?.name, { type: FileExtensionEnum.HEICMimetype });
    }

    formData.append('file', fileToUpload);

    if (this.scan == 'Yes') {
      this.spinnerService.show();
        this.uploadService.uploadScanFile(formData).subscribe(
        (uploadScanFileResponse: any) => {
          this.spinnerService.hide();
          
          this.uploadScanResult = uploadScanFileResponse;

          if (this.uploadScanResult.length == 1) {
            this.uplodedFileSuccessfullyCount++;
            this.onClickToStoreFilesToAzure(file, folderPathId, indexPosition);
          } else {
            this.azureFiles.splice(indexPosition, 1);

            this.isVirusFound++;
            this.virusInfectedFiles.push(file.name);
            this.emitErrorMessageFun();
          }
        },
        (error: HttpErrorResponse) => {
          this.spinnerService.hide();
          this.errorMessage =
            'Error occurred during file upload. Kindly reupload the file.';
          this.alert = true;
          this.azureFiles.splice(indexPosition, 1);
          this.emitErrorMessageFun();
        }
      );
    } else {
      this.uplodedFileSuccessfullyCount++;
      this.onClickToStoreFilesToAzure(file, folderPathId, indexPosition); 
    }
  }

  public async onClickToStoreFilesToAzure(
    file: any,
    folderPathId: string,
    indexPosition: number
  ) {
    this.spinnerService.show();
    let fileToUpload = file;

    let folderPath: string = 'accountRequestAndPODSubmission/' + folderPathId;

    var formData = new FormData();

    //A condition to manually set the mime type for HEIC file type 
    if(file?.name.split('.').pop().toLowerCase()==FileExtensionEnum.HEIC){
      //Convert to byte array
      const arrBuffer =  await fileToUpload?.arrayBuffer();
      const byteArray = new Uint8Array(arrBuffer);
    
      //Add to a blob
      var blobData = new Blob([byteArray], { type: FileExtensionEnum.HEICMimetype });
      //Generate file from blob with Mime Type and set it as a final file
      fileToUpload = new File([blobData], file?.name, { type: FileExtensionEnum.HEICMimetype });
    }

    const reader = new FileReader();
    reader.readAsDataURL(fileToUpload);
    reader.onload = () => {
      const base64String = reader.result.toString().split(',')[1];
      var convertedFileName = btoa(file?.name); // encoding original filename
        convertedFileName = convertedFileName.replace("==","__eq__");
        convertedFileName = convertedFileName.replace("=","_eq_");
    const newFormData = new FormData();
    const blob = new Blob([Uint8Array.from(atob(base64String), c => c.charCodeAt(0))], { type: fileToUpload.type });
    newFormData.append("file", blob, convertedFileName);
      this.uploadService.insertFile(newFormData,folderPath).subscribe(
        (azureStorageFilePath: any) => {
              file.filePath = azureStorageFilePath;
              var size = file.size;
              size = Math.round(size * 0.001);
              file.fileSize = size + 'Kb';
              file.date = new Date();
              file.convertedDate = moment.utc().utcOffset(8).format("DD MMM yyyy hh:mm A");
              this.azureFiles.push(file);
              this.uplodedFileSuccessfullyLength++;
              if (this.uplodedFileSuccessfullyLength == this.uplodedFileSuccessfullyCount) {
                  this.spinnerService.hide();
                  this.emitErrorMessageFun();
                  this.floatMessage.showNotification("success", this.uplodedFileSuccessfullyLength + " file(s) have been successfully uploaded.");
              }
              this.emitFiles.emit(this.azureFiles);
        },
          (error: HttpErrorResponse) => {
          this.uplodedFileSuccessfullyCount--;
          this.spinnerService.hide();
          if(error.status == 403){
            //this.azureFiles.splice(indexPosition, 1);
            this.isVirusFound++;
            this.virusInfectedFiles.push(file.name);
            this.errorMessage = "Please re-upload a fresh file instead of as it is virus infected";
              this.alert = true;
              this.emitErrorMessage.emit();
          }
          else if(error.status == 413){
            this.errorMessage = "Upload unsuccessful - File size should not exceed 10 MB ";
            this.alert = true;
            this.emitErrorMessage.emit();
            //this.azureFiles.splice(indexPosition, 1);
          }
          else if(error.status == 415){
            this.errorMessage = "Upload unsuccessful - Upload the documents in supported format only";
            this.alert = true;
            this.emitErrorMessage.emit();
            //this.azureFiles.splice(indexPosition, 1);
          } 
          else {
            this.emitErrorMessage.emit();
            this.errorMessage = error.message;
            this.alert = true;
            this.azureFiles.splice(indexPosition, 1);
              }
              this.emitErrorMessageFun();
        }
      );
    }
  }

  // To remove the file from azure....
  public onClickToDeleteAttachment(filePath: string) {
    this.spinnerService.show();
    this.alert = false;
      this.uploadService
      .deleteFile(filePath)
      .subscribe((apiResponse: any) => {
        this.spinnerService.hide();
        if (apiResponse) {
          this.azureFiles.forEach((file: any, index) => {
            if (file.filePath == filePath) {
              this.azureFiles.splice(index, 1);
              this.emitDeletedFile.emit(file);
            }
          });
          this.floatMessage.showNotification("success","File deleted successfully.");
          // this.dialog.open(DialogComponent, {
          //   disableClose: true,
          //   width: '673px',
          //   data: {
          //     oneButton: true,
          //     labelVal2: 'Document deleted successfully.',
          //     primaryButVal: 'OK',
          //   },
          //   panelClass: 'warning',
          // });
        }
      });
  }

  public onClickRemoveFile(filePath: string) {
    this.azureFiles.forEach((file: any, index) => {
      if (file.filePath == filePath) {
        this.azureFiles.splice(index, 1);
        this.emitDeletedFile.emit(file);
      }
    });
    this.floatMessage.showNotification("success","File deleted successfully.");
    // this.dialog.open(DialogComponent, {
    //   disableClose: true,
    //   width: '673px',
    //   data: {
    //     oneButton: true,
    //     labelVal2: 'Document deleted successfully.',
    //     primaryButVal: 'OK',
    //   },
    //   panelClass: 'warning',
    // });
  }

  public deleteAttachment() {
    this.deleteFiles.forEach(async file => {
      this.spinnerService.show();
        this.uploadService
        .deleteFile(file.filePath)
        .subscribe((apiResponse: any) => { this.spinnerService.hide(); });
    });
    
  }
  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}


